import { first, isArray, isEmpty, isNil } from 'lodash';
import { get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { TwilioNumber } from '../interfaces/twilio';
import { StoreState } from '../store-interfaces';
import { companyFeatureFlagsSelector } from './featureFlagsSelectors';
import { getTwilioAvailable } from './viewSelectors';

export const twillioSelector = (state: StoreState) => state.twilio;

export const twillioNumbersSelector = createSelector(
  [twillioSelector],
  get('numbers'),
);

export const twillioTestNumbersSelector = createSelector(
  [twillioSelector],
  get('testNumbers'),
);

export const twillioCallForwardingNumberSelector = createSelector(
  [twillioSelector],
  get('callForwardingNumber'),
);

export const twillioNumberSelector = createSelector(
  [twillioNumbersSelector],
  numbers => (isArray(numbers) ? first<TwilioNumber>(numbers) : null),
);

export const recentDiscardedSelector = createSelector(
  [twillioNumbersSelector],
  get('recentDiscarded'),
);

export const hasDeactivatedNumberSelector = createSelector(
  [recentDiscardedSelector],
  value => !isNil(value) || !isEmpty(value),
);

export const hasSMSNumberSelector = createSelector(
  [twillioNumbersSelector, hasDeactivatedNumberSelector],
  (twilioNumber, hasDeactivatedNumber) =>
    isArray(twilioNumber)
      ? !!twilioNumber.length
      : !!twilioNumber || hasDeactivatedNumber,
);

export const selectIsSmsSupported = createSelector(
  [companyFeatureFlagsSelector, getTwilioAvailable],
  (featureFlags, availableFlag) => {
    return featureFlags.twilio || availableFlag;
  },
);
